var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.39,
    height: 100,
    viewBox: "0 0 161.39 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f3d56;}.b{fill:#e6e6e6;}.c{fill:#fbae47;}.d{fill:#fff;}.e{fill:#d0cde1;}.f{fill:#ec008c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37.219)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.223,
    height: 15.785,
    transform: "translate(134.003 37.928)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.223,
    height: 88.787,
    transform: "translate(54.26 4.039) rotate(-67.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M260.386,667.191c-3.016,5.753-161.375,5.27-161.135,0C102.267,661.438,260.626,661.921,260.386,667.191Z",
    transform: "translate(-61.777 -571.327)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.342,
    height: 7.559,
    transform: "translate(156.597 71.406)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 95.374,
    height: 8.448,
    transform: "translate(78.786 79.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M682.1,298.248H659.2v-28.79h17.119l5.78,14.52Z",
    transform: "translate(-522.607 -216.067)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 9.782,
    height: 9.782,
    transform: "translate(140.296 54.401)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M744.143,289.534h-6.225v-9.782h2.668Z",
    transform: "translate(-586.918 -225.233)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.223,
    height: 4.224,
    transform: "translate(140.85 70.434)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M748.212,313.661h.111a2.112,2.112,0,0,1,2.112,2.112h0a2.112,2.112,0,0,1-2.112,2.112h-.111Z",
    transform: "translate(-595.297 -252.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M297.7,403.278h.111a2.112,2.112,0,0,1,2.112,2.112h0a2.112,2.112,0,0,1-2.112,2.112H297.7Z",
    transform: "translate(-225.655 -324.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M882.187,544.335a11,11,0,0,1,8.55,4.256h4.345l-4.224-11.766-19.675-3.88.556,15.647h1.9A11,11,0,0,1,882.187,544.335Z",
    transform: "translate(-714.807 -466.193)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.671,
    cy: 9.671,
    r: 9.671,
    transform: "translate(157.931 76.599)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.09,
    cy: 5.09,
    r: 5.09,
    transform: "translate(162.512 81.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 8.448,
    cy: 8.448,
    r: 8.448,
    transform: "translate(74.436 78.933)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.446,
    cy: 4.446,
    r: 4.446,
    transform: "translate(78.409 82.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.669,
    height: 33.681,
    transform: "translate(132.989 49.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 67.14,
    height: 2.001,
    transform: "translate(71.267 77.153)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 75.882,
    height: 2.001,
    transform: "translate(37.219 85.61) rotate(-15.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.556,
    height: 13.007,
    transform: "translate(102.216 67.752) rotate(-36.311)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.223,
    height: 0.889,
    transform: "translate(152.046 65.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M617.144,524.132H588.02a.222.222,0,0,1-.063-.435l28.457-8.448a.222.222,0,0,1,.285.2l.667,8.448a.223.223,0,0,1-.222.24Zm-27.594-.445H616.9l-.626-7.935Z",
    transform: "translate(-481.756 -452.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M288.676,379.469h0l-6.382-.06a.222.222,0,0,1-.219-.248l3.316-28.934a.222.222,0,0,1,.221-.2h0a.222.222,0,0,1,.22.2l3.066,28.994a.222.222,0,0,1-.221.246Zm-6.133-.5,5.886.055-2.828-26.74Z",
    transform: "translate(-230.575 -318.673)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H.111A2.112,2.112,0,0,1,2.223,2.112h0A2.112,2.112,0,0,1,.111,4.224H0Z",
    transform: "matrix(-0.935, 0.354, -0.354, -0.935, 177.503, 74.488)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.44,
    height: 1.022,
    transform: "translate(40.106 77.734) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.25,434.409l-1.2.653-48.628,13.611-.722-.9a10.678,10.678,0,0,1-2.31-5.35,4.493,4.493,0,0,1,.973-3.951L201.51,423.5l26.894-7.564,12.756,5.489s4.886-1.46,8.482,1.116a8.094,8.094,0,0,1,2.83,3.838l.588,1.7Z",
    transform: "translate(-164.036 -371.333)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 6.235,
    cy: 6.235,
    r: 6.235,
    transform: "translate(72.922 59.682)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.282,
    cy: 3.282,
    r: 3.282,
    transform: "translate(75.852 62.571)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 6.235,
    cy: 6.235,
    r: 6.235,
    transform: "translate(44.6 68.502)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.282,
    cy: 3.282,
    r: 3.282,
    transform: "translate(47.554 71.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M201.688,237.755l-19.294,5.4-1.626-5.808,12.3-3.444Z",
    transform: "translate(-129.795 -188.336)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 7.973,
    height: 6.031,
    transform: "translate(41.754 52.031) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.022,
    height: 1.942,
    transform: "translate(53.836 59.701) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.022,
    height: 1.942,
    transform: "translate(69.991 51.795) rotate(74.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H.112A2.136,2.136,0,0,1,2.249,2.136h0A2.136,2.136,0,0,1,.112,4.273H0Z",
    transform: "translate(67.78 48.313) rotate(-15.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.173,457.449a3.3,3.3,0,0,1-3.418-5.536,8.094,8.094,0,0,1,2.83,3.838Z",
    transform: "translate(-374.631 -401.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.223,
    height: 32.458,
    transform: "translate(53.788 2.001)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.112,
    cy: 3.112,
    r: 3.112,
    transform: "translate(51.814 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.112,
    cy: 3.112,
    r: 3.112,
    transform: "translate(131.988 34.848)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSupport);
export default __webpack_public_path__ + "static/media/menu-support.b78c3cb2c54ba9ddeaaa9e2820f0bac8.svg";
export { ForwardRef as ReactComponent };